module.exports = __webpack_public_path__ + "media/images/footer/bk-01c815229d1447e4fe84e0cbb3e4594c.svg";